var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-card',{attrs:{"title":_vm.title}},[_c('vs-tabs',{attrs:{"value":_vm.activeTab}},[_c('vs-tab',{attrs:{"label":"History"}},[_c('History')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }